import { render } from "./PutPage.vue?vue&type=template&id=75a0ff92&scoped=true&ts=true"
import script from "./PutPage.vue?vue&type=script&lang=ts"
export * from "./PutPage.vue?vue&type=script&lang=ts"

import "./PutPage.vue?vue&type=style&index=0&id=75a0ff92&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a0ff92"]])

export default __exports__